/**
 * Persists the hall-plan view (coloring, zoom level, pan position) per
 * event session so a page reload lands back where the user left off,
 * instead of resetting to the default overview every time.
 */
export interface HallPlanViewState {
  colorMode: string;
  k: number;
  x: number;
  y: number;
}

function storageKey(eventSessionId: string): string {
  return `seatingplan.hallplan.view.${eventSessionId}`;
}

export function loadHallPlanViewState(eventSessionId: string): HallPlanViewState | null {
  try {
    const raw = localStorage.getItem(storageKey(eventSessionId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed?.k !== "number" || typeof parsed?.x !== "number" || typeof parsed?.y !== "number") return null;
    return parsed as HallPlanViewState;
  } catch {
    // Private browsing / corrupted value — fall back to the default view.
    return null;
  }
}

export function saveHallPlanViewState(eventSessionId: string, state: HallPlanViewState): void {
  try {
    localStorage.setItem(storageKey(eventSessionId), JSON.stringify(state));
  } catch {
    // Quota exceeded or storage disabled — losing the view preference isn't worth surfacing an error for.
  }
}
